import { render } from "./AddCategoryPage.vue?vue&type=template&id=7da912f4"
import script from "./AddCategoryPage.vue?vue&type=script&lang=js"
export * from "./AddCategoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__